import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import actions from "./actions";
import Catalog from "./components/Catalog/";
import { extractFilterOptionsFromUrl, getPageFromLocation, getHashPrefix } from "./helpers";
import { getProductViewHistory } from "productViewHistory";
import { animateScroll as scroll } from "react-scroll";
import {
  JSONLD,
  Product,
  Generic,
  GenericCollection
} from "react-structured-data";
import { select } from "redux-saga/effects";

export class CatalogContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { filterDrawerOpen: false, recentlyViewedProducts: [] };
    this.updateMetaTags();
  }

  updateMetaTags() {
    const titleTag = document.querySelector("title");
    const descriptionTag = document.querySelector('meta[name="description"]');
    const type = this.props.type[0].toUpperCase() + this.props.type.slice(1);
    const canonicalTag = document.querySelector('link[rel="canonical"]');
    const hostPath = window.location.host;
    const currentPath = this.props.location.pathname;

    if (titleTag) {
        titleTag.innerHTML = `Fire Doorset Doors | Masonite UK Fire Doorsets`;
    }

    if (canonicalTag) {
        canonicalTag.href = `${hostPath}${currentPath}`;
    }
  }

  componentDidUpdate(prevProps) {
    const { actions, location, type: doorType, pathPrefix } = this.props;

    const filtersHaveChanged =
      location.pathname !== prevProps.location.pathname;
    const pageHasChanged =
      getPageFromLocation(location) !== getPageFromLocation(prevProps.location);

    if (filtersHaveChanged) {
      const selectedFilterOptions = extractFilterOptionsFromUrl(
        location.pathname
      ).map(this.toFilterOptionByHash);

      actions.updateFilters({
        doorType,
        filterOptions: selectedFilterOptions,
        pathPrefix
      });
      scroll.scrollToTop({ ignoreCancelEvents: true });
    } else if (pageHasChanged) {
      const filterOptions = extractFilterOptionsFromUrl(
        this.props.location.pathname
      ).map(this.toFilterOptionByHash);
      const page = getPageFromLocation(this.props.location);
      actions.changePage({
        doorType,
        filterOptions,
        page,
        pathPrefix
      });
      scroll.scrollToTop({ ignoreCancelEvents: true });
    }

    this.modifyExternalDomElements();
  }

  componentWillMount() {
    const { actions, location, type: doorType, pathPrefix } = this.props;
    const selectedFilterOptions = extractFilterOptionsFromUrl(
      location.pathname
    ).map(hash => ({ hash, selected: true }));
    const page = getPageFromLocation(location);

    this.setState({
      recentlyViewedProducts: getProductViewHistory()
    });

    actions.updateFilters({
      doorType,
      filterOptions: selectedFilterOptions,
      page,
      pathPrefix
    });

    this.modifyExternalDomElements();
  }

  /**
   * Modify external DOM elements.
   *
   * Modify elements outside of the React app, which are from WordPress.
   */
  modifyExternalDomElements() {
    if (this.props.wpFooterLoaded) {
      const el = document.querySelector(".before-footer");
      if (el) el.style.display = "block";
    }
  }

  toFilterOptionByHash = hash => {
    const prefix = getHashPrefix(hash);
    const option = this.props.filters.find(({ hash_prefix }) => prefix === hash_prefix).values.find(value => hash === value.hash);
    return option;
  };

  openFilterDrawer = () => {
    this.setState(state => ({
      filterDrawerOpen: !state.filterDrawerOpen
    }));
  };

  render() {
    return (
      <>
        <JSONLD>
          <Generic jsonldtype="WebPage" url={window.location.href}>
            <Generic type="mainEntity" jsonldtype="WebPageElement">
              <Generic type="offers" jsonldtype="Offer">
                <GenericCollection type="itemOffered">
                  {this.props.products &&
                    this.props.products.length > 0 &&
                    this.props.products.map(product => (
                      <Product key={product.hash} name={product.title} />
                    ))}
                </GenericCollection>
              </Generic>
            </Generic>
          </Generic>
        </JSONLD>
        <Catalog
          {...this.props}
          recentlyViewedProducts={this.state.recentlyViewedProducts}
          filterDrawerOpen={this.state.filterDrawerOpen}
          onOpenFilterDrawer={this.openFilterDrawer}
          visibleFilterLimit={7}
        />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    webFontsLoaded: state.app.webFontsLoaded,
    filters: state.catalog.filters,
    products: state.catalog.products,
    pagination: state.catalog.pagination,
    aboveFooterContent: state.catalog.above_footer_content,
    loading: state.catalog.loading,
    wpFooterLoaded: state.app.wpFooterLoaded,
    routeRoots: {
      catalog: state.catalog.routeRoot,
      productDetails: state.productDetails.routeRoot
    }
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

CatalogContainer.propTypes = {
  filters: PropTypes.array,
  results: PropTypes.array,
  type: PropTypes.string
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CatalogContainer)
);
